import React from 'react';
import Styled from 'styled';
import defaultStyles from './related-products.scss';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client/react/hooks';

import ProductsGrid from 'four-nets/bazaar/products/products-grid/products-grid';

import query, { RelatedProductsQuery, RelatedProductsQueryVariables } from './related-products.graphql';
import { fromGlobalId } from 'graphql-relay';

interface Props {
    styles: typeof defaultStyles;
    searchApi: any;
    originalProductName: string;
    originalProductId: number;
}

interface State {
    products: any;
}

const RelatedProducts: React.FC<Props> = props => {
    const { styles, originalProductName, originalProductId } = props;

    const { data } = useQuery<RelatedProductsQuery, RelatedProductsQueryVariables>(query, {
        variables: { search: originalProductName },
    });

    return data && data.products && data.products.edges && data.products.edges.length ? (
        <div className={styles.relatedProductsWrapper}>
            <div className={styles.title}>
                <h2 className={styles.heading}>
                    <FormattedMessage id='BAZAAR_SIMILAR_PRODUCTS' />
                </h2>
                <FormattedMessage id='BAZAAR_PRODUCTS' values={{ counter: data.products.edges.length }} />
            </div>
            <ProductsGrid
                interscroller={false}
                edges={data.products.edges.filter(
                    (edge: any) => fromGlobalId(edge && edge.node && edge.node.id).id !== String(originalProductId)
                )}
            />
        </div>
    ) : null;
};

export default Styled(defaultStyles)(RelatedProducts);
